import io from "socket.io-client";
import { getBackendUrl } from "../utils/backendUrl";

const getAuthToken = () => {
  let token = localStorage.getItem("token");
  if (!token) {
    token = sessionStorage.getItem("token");
  }
  if (!token) return null;

  try {
    return JSON.parse(token);
  } catch {
    return token.replace(/^"|"$/g, "");
  }
};

class SocketWorker {
  constructor(companyId, userId) {
    const shouldRecreate =
      !SocketWorker.instance ||
      SocketWorker.instance.companyId !== companyId ||
      SocketWorker.instance.userId !== userId;

    if (shouldRecreate) {
      if (SocketWorker.instance?.socket) {
        SocketWorker.instance.socket.disconnect();
      }

      this.companyId = companyId;
      this.userId = userId;
      this.socket = null;
      this.eventListeners = {};
      this.configureSocket();
      SocketWorker.instance = this;
    }

    return SocketWorker.instance;
  }

  configureSocket() {
    const backendUrl = getBackendUrl() || window.location.origin;
    const token = getAuthToken();

    this.socket = io(`${backendUrl}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      query: {
        userId: this.userId,
        ...(token ? { token } : {}),
      },
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", () => {
      console.log("Desconectado do servidor Socket.IO");
      this.reconnectAfterDelay();
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {
    this.connect();
    if (!this.socket) return;

    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    if (!this.socket) return;

    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    this.connect();
    if (!this.socket) return;

    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
    SocketWorker.instance = null;
    console.log("Socket desconectado manualmente");
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;